import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LocaleService } from '@domain/localization';
import { ColumnDataTypes } from '@database/models';
import { TranslateService } from '@ngx-translate/core';
import {
	AppVariables,
	DATE_FORMATTING_PIPE,
	DATE_TIME_FORMATTING_PIPE,
	TIME12_FORMATTING_PIPE,
	TIME24_FORMATTING_PIPE,
	TIME12_FORMATTING
} from '../constants';

@Injectable({
	providedIn: 'root'
})
export class FormattingService {
	private currentLocaleName: string = this.locale.getLocaleName();
	private localeName: string = AppVariables.I18N_SUPPORTED_LANGUAGES.includes(this.currentLocaleName)
		? this.currentLocaleName
		: AppVariables.I18N_SUPPORTED_LANGUAGES_FALLBACK;

	public constructor(
		private locale: LocaleService,
		private translateService: TranslateService
	) {}

	public transformValue(value: string, valueType: string): string | number | Date {
		switch (valueType) {
			case ColumnDataTypes.DATE:
				return new DatePipe(this.localeName).transform(value, DATE_FORMATTING_PIPE);
			case ColumnDataTypes.DATETIME:
				return new DatePipe(this.localeName).transform(value, DATE_TIME_FORMATTING_PIPE);
			case ColumnDataTypes.TIME12:
				return new DatePipe(this.localeName).transform(value, TIME12_FORMATTING_PIPE);
			case ColumnDataTypes.TIME24:
				return new DatePipe(this.localeName).transform(value, TIME24_FORMATTING_PIPE);
			case ColumnDataTypes.IMAGE:
				return value
					? this.translateService.instant('signature.isSigned')
					: this.translateService.instant('signature.notSigned');
			default:
				return value;
		} 
	}
	
}
